import { last, head } from 'lodash';
export const FIELD_PATH_SEPARATOR = '.';
export const toFieldPath = (fieldName, referenceFieldName) => referenceFieldName
    ? [referenceFieldName, fieldName].join(FIELD_PATH_SEPARATOR)
    : fieldName;
export const getFieldFromReferencedCollectionName = (fieldPath) => last(fieldPath.split(FIELD_PATH_SEPARATOR));
export const getReferenceFieldName = (fieldPath) => head(fieldPath.split(FIELD_PATH_SEPARATOR));
//# sourceMappingURL=referenceFieldPath.js.map